





































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vnodes from '@/components/helpers/vnode-helper';

import Resizer from './resizer';
import Selection from './selection';
import Formatter from './formatter';
import Sort from './sort';
import Tree from '@/views/report/Tree.vue';
import ReportSorting from '@/views/reports/pickers/report-sorting.vue';
import { normalizeId } from '@/components/datatable/table-selection';
import globalBus from '@/services/evbus';
import MetricsMixin from '@/views/reports/pickers/base/metrics-mixin';
// @ts-ignore
import { showTotalTypeForColumn } from '@/views/formatters';

@Component({
  components: {
    Vnodes,
    ReportSorting,
    Tree,
    MetricsMixin,
  }
})
export default class ReportTable extends mixins<Selection, Formatter, Resizer, Sort>(Selection, Formatter, Resizer, Sort) {
  @Prop({ default: [] })
  headers: any[];

  @Prop()
  columnsWidth!: any;

  @Prop({default: false})
  generateIds!: boolean;

  @Prop({default: false})
  treeRoot!: boolean;

  @Prop({default: null})
  idPrefix!: string;

  @Prop({ default: {} })
  footer: object;

  @Prop({ default: {} })
  tree: any;

  @Prop({ default: false })
  selectable: boolean;

  @Prop({ default: false })
  selectOnRowClick: boolean;

  @Prop()
  type: string;

  @Prop({ default: true })
  treeLoading: boolean;

  @Prop({ default: [] })
  items: any[];

  @Prop({ default: [] })
  columnsFilter: any[];

  @Prop({ default: false })
  isShowTreeView: boolean;

  @Prop()
  previousFilter!: Bemob.ReportQueryDrill[];

  rowKey: string = 'DT_RowId'

  scrolledItems: any = []
  
  getTotalType(value) {
    if(showTotalTypeForColumn(value) && this.$store.state.user.reportTotalLabelEnabled) {
      switch (this.$store.getters.getColumns[this.storeColumns]?.totalType?.[value]) {
        case 'avg':
          return this.t('Avg.');
        case 'sum':
          return this.t('Sum.');
        default:
          return this.t('Def.')
      }
    }
  }

  getCellWidth(value, i) {
    if (i === 0) {
      switch (this.treeLevel) {
        case 1:
          return this.getColumnWidth(value) - (this.treeLevel * this.tableOffset) + (this.treeView.length ? 0 : 27)
        case 2:
          return this.getColumnWidth(value) - (this.tableOffset)

        default:
          return this.getColumnWidth(value)
      }
    }

    return this.getColumnWidth(value)
  }

  onDrilldownForward(item, grouping) {
      this.$emit('drilldown-forward', item, grouping)
  }

  get isAllowSelectRow() {
    return this.selectable
  }

  get showTotalTypeOnPage() {
    switch(this.$route.name) {
      case 'app.live-clicks':
      case 'app.live-visits':
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
        return false;
      default:
        return true;
    }
  }

  get treeViewValue() {
    return this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((item)=>!!item) || []
  }

  get isCheckboxInRow() {
    return !this.treeView.length && this.multiSelect
  }

  get multiSelect() {
    const isMainReportType= ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'].includes(this.$route.params.type)
    const isMainReportTypeOrCustomOrPostback= isMainReportType || this.$route.params?.type?.includes('custom') || ['app.postbacks'].includes(this.$route.name)
    const isReport = !!this.$route.params.report || ['app.postbacks']
    const isOnlyOneGroupBy = this.treeViewValue?.length===0
    // for home
    if(!isReport && isMainReportType){
      return true
    }

    // for report
    return isOnlyOneGroupBy && isMainReportTypeOrCustomOrPostback;
  }

  get tableOffset() {
    if(this.treeLevel>0){
      return 27
    }
    return 0
  }

  get firstColumnsOffset() {
    if(this.multiSelect || this.treeView.length){
      return 38
    }
    return 12
  }

  footerCell(value) {
    return this.formatCellValue({ value, obj:this.footer, isFooter:true })
  }

  get mappedTableData() {
    return this.tableData.reduce((acc, item) => {
      acc[item.DT_RowId] = {
        ...item,
        grouping: this.columnsFilter[this.treeLevel],
        parentID:this.parentRow.DT_RowId
      }

      return acc
    }, {})
  }

  get isSelectAll() {
    return Object.keys(this.checkboxState).length && Object.keys(this.checkboxState).length === this.tableData.length
  }

  set isSelectAll(value) {
    this.checkboxState = value ? {...this.mappedTableData} : {}
  }

  onContextClick(item, event) {
    if ((this as any).isAllowSelectRow) {
      event.preventDefault()

      globalBus.emit('clear-row-context');

      if (!(Object.keys(this.checkboxState).length === 1 && this.checkboxState[item.DT_RowId])) {
        this.checkboxState = { [item.DT_RowId]: item }
      }

      const eventData = this.selectedItems.map((item) => ({
        ...item,
        DT_RowId: normalizeId(item.DT_RowId)
      }));

      setTimeout(() => globalBus.$emit('row-contextmenu', eventData, event.clientY, event.clientX, this.treeLevel), 100);
    }
  }

  onDblClick(item) {
    if (!(this as any).isAllowSelectRow) {
      return
    }

    const id = normalizeId(item[this.rowKey]);

    const normalizedItem = {
      ...item,
      [this.rowKey]: id,
      id: id
    };

    this.bus.emit('row-report', normalizedItem, this.grouping);
  }

  isHasTree(row) {
    return !!(this.tree && this.tree[row[this.rowKey]]);
  }

  onClickTree(row) {
    this.$emit('tree', row, this.grouping)
  }

  chevronIcon(item) {
    return this.tree && this.tree[item[this.rowKey]] ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
  }

  isChevronIcon(item) {
    return this.tree && this.tree[item[this.rowKey]]
  }

  profitClass(item: any) {
    if (item['reports-profit'] > 0) {
      return 'success';
    } else if (item['reports-profit'] < 0) {
      return 'danger';
    } else {
      return 'secondary';
    }
  }

  onMouseMove(event) {
    this.resizeColumn(event)
  }

  onMouseUp(event) {
    this.onDragEnd(event)
  }

  get treeTableHeaders() {
    const tableHeaders = JSON.parse(JSON.stringify(this.tableHeaders));
    const {treeLevels, view} = this.$store.getters.tableQueryForCurrentTab;
    const { dimensions } = this.$store.state.reportColumns;
    const filteredTreeLevels = treeLevels?.filter((item) => !!item) || [];
    if(this.treeLevel > 0 && view==='tree' && filteredTreeLevels?.[this.treeLevel-1]){
      const key = filteredTreeLevels[this.treeLevel-1]
      tableHeaders.splice(0, 1, dimensions[key].mainColumn )
    }
    return tableHeaders.map(columnName => {
      if (this.treeLevel > 0 && this.grouping === columnName) {
        return {
          treeValue: this.columnsFilter[this.treeLevel],
          value: columnName,
        }
      }

      return { value: columnName }
    })
  }

  openFooterTotalSettings() {
    this.bus.emit('open-dialog', { name: 'ReportTotalSettings' });
  }

  mounted() {
    const resizerWrapper = this.$refs['resizer-wrapper'] as any
    if(this.treeLevel===0){
    
      document.addEventListener('mousemove', this.onMouseMove.bind(this));
      document.addEventListener('mouseup', this.onMouseUp.bind(this));
      resizerWrapper?.addEventListener('touchmove', this.onMouseMove.bind(this), { passive: false });
      resizerWrapper?.addEventListener('touchend', this.onMouseUp.bind(this), { passive: false });
    }
  }

  beforeDestroy() {
    const resizerWrapper = this.$refs['resizer-wrapper'] as any

    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
    resizerWrapper?.removeEventListener('touchmove', this.onMouseMove);
    resizerWrapper?.removeEventListener('touchend', this.onMouseUp);
  }

  @Watch('$route.params')
  changeType() {
    this.resetTableWidth()
    this.isSelectAll = false
  }

  get tableData() {
    return this.items
  }
}
